import { lazy } from 'react'
import { redirect } from 'react-router-dom'

import { JobLevelRateDetailsDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { RoleDetailsHeader } from 'modules/project_management/components/headers/RoleDetailsHeader'

const JobsAndRatesRootPage = lazy(
  () => import('modules/project_management/pages/JobsAndRatesRootPage/index')
)
const JobsAndRatesListPage = lazy(
  () => import('modules/project_management/pages/JobsAndRatesPage/index')
)
const RoleDetailsPage = lazy(
  () => import('modules/project_management/pages/JobsAndRatesPage/RoleDetailsPage/index')
)

export const jobsAndRatesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.projects.jobsAndRates.path,
      element: <JobsAndRatesRootPage />,
      handle: {
        meta: () => ({
          title: i18n.t('project_management.meta_data.jobs_and_rates.title'),
        }),
      },
      children: [
        {
          index: true,
          loader: () => redirect(navigation.projects.jobsAndRates.list.path),
        },
        {
          path: navigation.projects.jobsAndRates.list.path,
          element: <JobsAndRatesListPage />,
        },
        {
          path: navigation.projects.jobsAndRates.jobLevelId.path,
          element: <RoleDetailsPage />,
          handle: {
            resource: true,
            meta: ({ params, watchQuery, session }) => {
              return watchQuery({
                query: JobLevelRateDetailsDocument,
                fetchPolicy: 'cache-first',
                variables: {
                  id: Number(params['jobLevelId']),
                  companyId: session.company.id,
                  resourceType: 'JobCatalog::TreeLevel',
                },
              }).map(({ data }) => {
                const rate = data.projectManagement.ratesConnection.nodes[0]
                const isTotalProfitabilityEnabled = !!data.features.featuresConnection.nodes.find(
                  (feature) => feature.name === 'dev_projects_total_profitability'
                )?.enabled

                const canManageRate = !!data.projectManagement._policies.rateManage.can

                if (!isTotalProfitabilityEnabled) return

                if (!rate) {
                  return { title: '' }
                }
                return {
                  title: rate.resourceJobTreeLevel?.ancestor?.name,
                  headerComponent: (
                    <RoleDetailsHeader
                      billRate={rate.billingRateCents}
                      canManageRate={canManageRate}
                      currency={rate.currency}
                      levelName={rate.resourceJobTreeLevel?.name ?? ''}
                      maxCostRate={rate.chargingCostCents}
                      minProfitMargin={rate.profitabilityPercentageCents}
                      roleName={rate.resourceJobTreeLevel?.ancestor?.name ?? ''}
                      roleLevelId={rate.resourceJobTreeLevel?.id ?? 0}
                    />
                  ),
                }
              })
            },
          },
        },
      ],
    },
  ]
}
